const $ = window.jQuery;
const $window = window.$window || $(window);

module.exports = {
    init() {
        this.scroll()
        this.scrollMobile()
    },

    scroll() {
        if(!$('.hero')) return;
        const svg = document.querySelector('svg#heroSvg');
        if (!svg) {return null}
        let path = svg.querySelector('path');
        svg.classList.remove('opacity-0');
        let pathLength = path.getTotalLength();
        path.style.strokeDasharray = pathLength + ' ' + pathLength
        path.style.strokeDashoffset = pathLength
        var divHeight = $('.hero').height();
        window.addEventListener('scroll', () => {
           var scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (divHeight - document.documentElement.clientHeight);
           var drawLength = pathLength * scrollPercentage;
           path.style.strokeDashoffset = pathLength - drawLength;
       })
    },
    scrollMobile() {
        if(!$('.hero')) return;
        const svg = document.querySelector('svg#heroSvgMobile');
        if (!svg) {return null}
        let path = svg.querySelector('path');
        svg.classList.remove('opacity-0');
        let pathLength = path.getTotalLength();
        path.style.strokeDasharray = pathLength + ' ' + pathLength
        path.style.strokeDashoffset = pathLength
        var divHeight = $('.hero').height();
        window.addEventListener('scroll', () => {
            var scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (divHeight - document.documentElement.clientHeight);
            var drawLength = pathLength * scrollPercentage;
            path.style.strokeDashoffset = pathLength - drawLength;
        })
    }
}
